import { ICON_BASE_PATH } from "@/app/utils/config";

interface NoteBarProp {
  children: React.ReactNode;
}
export default function NoteBarBlue({ children }: NoteBarProp) {
  return (
    <div className="gx-note-bar-blue-container">
      <img src={`${ICON_BASE_PATH}info_icon_blue.svg`} alt="info" />
      <p className="gx-p12-r">{children}</p>
    </div>
  );
}
